import { render, staticRenderFns } from "./AdminFormView.vue?vue&type=template&id=17bde810"
import script from "./AdminFormView.vue?vue&type=script&lang=js"
export * from "./AdminFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports